class CartItemVariantPicker extends HTMLElement {
  connectedCallback() {
    this.variantsData = JSON.parse(this.querySelector('[data-variants-json]').textContent);
    this.itemKey = this.dataset.itemKey;
    this.itemQuantity = parseInt(this.dataset.itemQuantity);
    this.currentVariantId = parseInt(this.dataset.currentVariantId);
    this.toggleBtn = this.previousElementSibling;

    this.toggleBtn.addEventListener('click', this.toggle.bind(this));
    this.querySelectorAll('.cart-variant-option__btn').forEach(btn => {
      btn.addEventListener('click', this.onOptionSelect.bind(this));
    });
  }

  toggle() {
    const opening = this.hasAttribute('hidden');
    this.toggleAttribute('hidden', !opening);
    this.toggleBtn.textContent = opening ? 'Done' : 'Edit';
    this.toggleBtn.setAttribute('aria-expanded', String(opening));
  }

  onOptionSelect(e) {
    const btn = e.currentTarget;
    const group = btn.closest('.cart-variant-option__group');

    group.querySelectorAll('.cart-variant-option__btn').forEach(b => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');

    const selectedValues = this.getSelectedValues();
    const newVariant = this.findVariant(selectedValues);
    if (!newVariant || newVariant.id === this.currentVariantId) return;

    this.swapVariant(newVariant);
  }

  getSelectedValues() {
    return Array.from(this.querySelectorAll('.cart-variant-option__group')).map(group => {
      return group.querySelector('.cart-variant-option__btn.is-selected')?.dataset.value;
    });
  }

  findVariant(selectedValues) {
    return this.variantsData.find(v =>
      v.options.every((opt, i) => opt === selectedValues[i])
    );
  }

  swapVariant(newVariant) {
    this.setLoading(true);
    const root = window.Shopify.routes.root;

    fetch(`${root}cart/change.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this.itemKey, quantity: 0 })
    })
    .then(() => fetch(`${root}cart/add.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: newVariant.id, quantity: this.itemQuantity })
    }))
    .then(() => {
      document.querySelector('m-cart-drawer')?.onCartDrawerUpdate();
    })
    .catch(() => {
      this.setLoading(false);
    });
  }

  setLoading(isLoading) {
    this.toggleAttribute('data-loading', isLoading);
    this.querySelectorAll('.cart-variant-option__btn').forEach(btn => {
      btn.disabled = isLoading;
    });
    if (this.toggleBtn) this.toggleBtn.disabled = isLoading;
  }
}

customElements.define('cart-item-variant-picker', CartItemVariantPicker);
